import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

function useFormStatus() {
    const { formState: { errors, isValid } } = useFormContext();
    return useMemo(() => {
        if (isValid)
            return 'valid';
        if (Object.keys(errors).length)
            return 'error';
        return 'pending';
    }, [errors, isValid]);
}

export { useFormStatus };
//# sourceMappingURL=useFormStatus.esm.js.map
